import React from 'react';
import styled from 'styled-components';

const ContactContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 2rem;
  background-color: #f5f5f5;
  border-radius: 8px;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  
  label {
    font-weight: bold;
  }
  
  input, textarea {
    padding: 0.5rem;
    border: 1px solid var(--gray);
    border-radius: 4px;
    font-size: 1rem;
    
    &:focus {
      outline: 2px solid var(--primary);
      border-color: var(--primary);
    }
  }
  
  textarea {
    min-height: 150px;
  }
`;

const SubmitButton = styled.button`
  background-color: var(--primary);
  color: white;
  padding: 1rem 2rem;
  border-radius: 4px;
  font-weight: bold;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #0090cc;
  }
`;

const Contact: React.FC = () => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission here
    alert('Form submission placeholder - will be implemented later');
  };

  return (
    <ContactContainer>
      <h1>Contact Us</h1>
      <p>Have a question? We'd love to hear from you!</p>
      
      <ContactForm onSubmit={handleSubmit}>
        <FormGroup>
          <label htmlFor="name">Name</label>
          <input type="text" id="name" required />
        </FormGroup>
        
        <FormGroup>
          <label htmlFor="email">Email</label>
          <input type="email" id="email" required />
        </FormGroup>
        
        <FormGroup>
          <label htmlFor="subject">Subject</label>
          <input type="text" id="subject" required />
        </FormGroup>
        
        <FormGroup>
          <label htmlFor="message">Message</label>
          <textarea id="message" required />
        </FormGroup>
        
        <SubmitButton type="submit">Send Message</SubmitButton>
      </ContactForm>
    </ContactContainer>
  );
};

export default Contact; 